<div class="row no-gutter layout-header topClass">
  <div class="col-md-7 col-sm-12 d-flex">
    @if (auth.userDetails.role != 'fielduser') {
      <h6 class="head vertical-line">
        Manage Users
      </h6>
    }
    <h6 class="head">Profile</h6>
  </div>
</div>

<div class="row layout profileCss">
  <div class="my-profile-container">
    <div class="row no-gutter">
      <div class="col col-sm-12 col-lg-12 col-xs-12 profile-container">
        <div class="profile">
          <div class="profile-logo">
            <button class="logo" matBadgeColor="success" matBadgePosition="below" matBadgeSize="small" matBadge=".">
              {{ auth.userDetails.firstname.charAt(0) }}
            </button>
          </div>
          <div class="profile-info">
            <div class="user-data">
              <div>
                <h3 class="name">
                  {{ auth.userDetails.firstname }}
                  {{ auth.userDetails.lastname }}
                  @if (auth.userDetails.role == 'superadmin') {
                    <span>
                      <img src="../../../../assets/images/super-admin-badge.svg" />
                    </span>
                  }
                  @if (auth.userDetails.role == 'fielduser') {
                    <span>
                      <img src="../../../../assets/images/field-user-badge.svg" />
                    </span>
                  }
                  @if (auth.userDetails.role == 'Vendoradmin') {
                    <span>
                      <img src="../../../../assets/images/vendor-admin-badge.svg" />
                    </span>
                  }
                  @if (
                    auth.userDetails.role !== 'fielduser' &&
                    auth.userDetails.role !== 'Vendoradmin' &&
                    auth.userDetails.role !== 'superadmin'
                    ) {
                    <span>
                      <img class="patch-{{ auth.userDetails.role }}"
                        src="../../../../assets/images/patch-check-fill.svg" />
                      </span>
                    }
                  </h3>
                  <div class="user-info">
                    <div class="org">
                      <i class="pi pi-user icon" aria-hidden="true"></i>
                      <span>{{ auth.userDetails.role }}</span>
                    </div>
                    <div class="location">
                      <i class="pi pi-map-marker icon" aria-hidden="true"></i>
                      <span>{{
                        vendorName ? vendorName : auth.userDetails.vendor.orgName
                      }}</span>
                      <!-- <span *ngIf="auth.userDetails.role === 'superadmin'">Aziro Technologies</span> -->
                    </div>
                    <div class="phone">
                      <i class="pi pi-phone icon" aria-hidden="true"></i>
                      <span>+91 {{ auth.userDetails.mobile }}</span>
                    </div>
                  </div>
                </div>
                <div>
                  @if (checked) {
                    <div class="form-actions">
                      <button type="button" class="cancel-action" name="cancelClass" (click)="onCancel()">
                        <span>Cancel</span>
                      </button>
                      <button type="button" class="create-action" name="submitClass" (click)="confirmSaving()">
                        <span>Save</span>
                      </button>
                    </div>
                  }
                </div>
                @if (
                  !checked &&
                  !(role == 'fielduser' && this.sharedService.profileSites) &&
                  !inChangePassword
                  ) {
                  <div class="imageClass" (click)="editable()">
                <img [src]="
                    hovered
                      ? '../../../../assets/images/action-on-hover.svg'
                      : '../../../../assets/images/action-normal.svg'
                  " style="cursor: pointer" (mouseover)="hover()" (mouseout)="out()" />
                    </div>
                  }
                </div>
                <div class="count-data">
                  <div class="count-info">
                    @if (!hideCount) {
                      <div class="onboarding-count">
                        <p class="count">{{ onboardCount }}</p>
                        <p class="name">Total Onboarding</p>
                      </div>
                    }
                    @if (auth.userDetails.role != 'fielduser') {
                      <div class="red-flag-count">
                        <p class="count">{{ userCount ? userCount.count : "" }}</p>
                        <p class="name">Total Users</p>
                      </div>
                    }
                  </div>
                  <mat-card class="progress-card">
                    <div class="progress-content">
                      <div class="progress-info">
                        <p class="status">Profile Status</p>
                        <p class="active">Active</p>
                      </div>
                      <mat-progress-bar mode="determinate" value="100"></mat-progress-bar>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-sm-12 col-xs-12 tab-container">
            <nav mat-tab-nav-bar animationDuration="0ms" [tabPanel]="tabPanel" preserveContent>
              <a mat-tab-link routerLink="/profile/my-profile" routerLinkActive #profile="routerLinkActive"
                [ngClass]="profile.isActive ? 'tab-active' : ''" [active]="profile.isActive">Overview
              </a>
              <a mat-tab-link routerLink="/profile/my-sites" routerLinkActive #mysites="routerLinkActive"
                [ngClass]="mysites.isActive ? 'tab-active' : ''" [active]="mysites.isActive">My Sites
              </a>
              <a mat-tab-link routerLink="/profile/change-password" routerLinkActive #password="routerLinkActive"
                [ngClass]="password.isActive ? 'tab-active' : ''" [active]="password.isActive">Change Password
              </a>
            </nav>
            <div class="col-sm-12">
              <div class="tab-body">
                <mat-tab-nav-panel #tabPanel>
                  <router-outlet></router-outlet>
                </mat-tab-nav-panel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>